"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureAppName = void 0;
/**
 * Use package name and normalize it to feature app name.
 * This is particularly useful when package names include scope
 * e.g. @oneaudi/feature-app-name becomes featureAppName
 * @param {string} pkgName Package name
 * @returns {string}
 */
var featureAppName = function (pkgName) {
    return pkgName.replace(/\@\S*\//, '');
};
exports.featureAppName = featureAppName;
